import { useEffect, useState } from "react";
import { apiGet, apiPost } from "../api/api";

export default function Operadores() {
  const [operadores, setOperadores] = useState([]);
  const [novoNome, setNovoNome] = useState("");
  const [msg, setMsg] = useState("");

  // ============================
  // 🔄 Carregar operadores
  // ============================
  async function load() {
    try {
      const data = await apiGet("/operadores/");
      setOperadores(data);
    } catch {
      setMsg("Erro ao carregar operadores");
    }
  }

  useEffect(() => {
    load();
  }, []);

  // ============================
  // ➕ Criar operador
  // ============================
  async function criarOperador() {
    if (!novoNome.trim()) {
      setMsg("O nome não pode estar vazio");
      return;
    }

    try {
      await apiPost("/operadores/", { nome: novoNome });
      setNovoNome("");
      setMsg("");
      load();
    } catch {
      setMsg("Erro: operador pode já existir");
    }
  }

  // ============================
  // 🗑 Apagar operador
  // ============================
  async function apagarOperador(id) {
    if (!window.confirm("Tem a certeza que deseja apagar?")) return;

    await fetch(`/api/operadores/${id}`, {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
      },
    });

    load();
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Gestão de Operadores</h2>

      {msg && <p style={{ color: "red" }}>{msg}</p>}

      {/* Criar operador */}
      <div
        style={{
          marginTop: 20,
          padding: 15,
          background: "#f7f7f7",
          borderRadius: 8,
          width: "100%",
          maxWidth: 400,
        }}
      >
        <h3>Novo Operador</h3>

        <input
          placeholder="Nome do operador"
          value={novoNome}
          onChange={(e) => setNovoNome(e.target.value)}
          style={{ width: "100%", padding: 8 }}
        />

        <button
          onClick={criarOperador}
          style={{
            marginTop: 10,
            padding: "8px 15px",
            background: "#2e7d32",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Criar
        </button>
      </div>

      {/* Listagem */}
      <h3 style={{ marginTop: 30 }}>Operadores existentes</h3>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#ddd" }}>
            <th style={{ padding: 10 }}>ID</th>
            <th style={{ padding: 10 }}>Nome</th>
            <th style={{ padding: 10 }}>Ações</th>
          </tr>
        </thead>

        <tbody>
          {operadores.map((op) => (
            <tr key={op.id} style={{ borderBottom: "1px solid #ccc" }}>
              <td style={{ padding: 10 }}>{op.id}</td>
              <td style={{ padding: 10 }}>{op.nome}</td>

              <td style={{ padding: 10 }}>
                <button
                  onClick={() => apagarOperador(op.id)}
                  style={{
                    padding: "6px 12px",
                    background: "#c62828",
                    color: "white",
                    border: "none",
                    borderRadius: 6,
                    cursor: "pointer",
                  }}
                >
                  Apagar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
